import { ActivityIndicator } from "@components/ActivityIndicator";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body } from "@components/Typography";
import { usePastTransactions, useScrollEndEffect } from "@hooks";
import { Translations, i18n } from "@i18n";
import { TransactionList } from "@routes/TransfersRoute/TransactionList";
import { useState } from "react";
import { styles } from "./styles";

export const PastTransfers = () => {
  const [isFetching, setIsFetching] = useState(false);

  const { data, loading, error, fetchMore } = usePastTransactions();

  useScrollEndEffect({
    fetchMore: async () => {
      if (!isFetching) {
        setIsFetching(true);
        try {
          await fetchMore();
        } finally {
          setIsFetching(false);
        }
      }
    },
  });

  if (loading) return null;

  if (error) {
    return (
      <>
        <Spacing size={SpacingSizes.M} />
        <Body>{i18n.t(Translations.GenericErrorMessage)}</Body>
      </>
    );
  }

  if (data.length === 0) {
    return (
      <>
        <Spacing size={SpacingSizes.M} />
        <Body>{i18n.t(Translations.TransfersRoutePastNoTransfers)}</Body>
      </>
    );
  }

  return (
    <>
      <TransactionList data={data} />
      {isFetching ? (
        <div style={styles.loader}>
          <ActivityIndicator />
        </div>
      ) : null}
    </>
  );
};
